import { render, staticRenderFns } from "./MemberIconText.vue?vue&type=template&id=66044dc0&scoped=true&lang=pug"
import script from "./MemberIconText.vue?vue&type=script&lang=js"
export * from "./MemberIconText.vue?vue&type=script&lang=js"
import style0 from "./MemberIconText.vue?vue&type=style&index=0&id=66044dc0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66044dc0",
  null
  
)

export default component.exports